module.exports = __webpack_public_path__ + "static/media/alpine-four-pack.b7aa3f5b.png";